import _ from 'lodash';
import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { BiDownArrowAlt } from 'react-icons/bi';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import AccountTypeEnum from '~Api/Investor/AccountTypeEnum';
import IAnnualStatement from '~Api/Investor/IAnnualStatement';
import IInvestor from '~Api/Investor/IInvestor';
import { annualStatementsListAction, currentInvestorGetAction } from '~Investor/actions';
import { currentInvestorAccountAnnualStatementsSelector, currentInvestorSelector } from '~Investor/selectors';
import { IGlobalState } from '~reducer';
import { IDictionary } from '~utilities/IDictionary';
import Pagination from '~UI/Pagination';

interface IState {
    currentPage: number;
    perPage: number;
}

interface IPropsSelector {
    annualStatements: IDictionary<IAnnualStatement>;
    currentInvestor: IInvestor;
}

interface IPropsDispatch {
    annualStatementsList: () => void;
    currentInvestorGet: () => void;
}

type Props = IPropsSelector & IPropsDispatch;

class AnnualStatements extends React.Component<Props, IState> {
    public state: IState = {
        currentPage: 1,
        perPage: 3,
    };

    constructor(props: Props) {
        super(props);

        this.onClickPage = this.onClickPage.bind(this);
    }

    public componentDidMount(): void {
        const { annualStatements, currentInvestor } = this.props;

        if (!annualStatements) {
            this.props.annualStatementsList();
        }

        if (!currentInvestor) {
            this.props.currentInvestorGet();
        }
    }

    public render(): JSX.Element {
        const { annualStatements, currentInvestor } = this.props;
        const { currentPage, perPage } = this.state;

        if (!annualStatements || !currentInvestor) {
            return (
                <div className='content-box'>
                    <Spinner animation='border' />
                </div>
            );
        }

        const offset: number = (currentPage - 1) * perPage;
        const sortedAnnualStatements: IAnnualStatement[] = _.orderBy(_.values(annualStatements), ['year'], ['desc']);
        const pageAnnualStatements: IAnnualStatement[] = sortedAnnualStatements.slice(offset, offset + perPage);

        const statementsBlock: JSX.Element[] = _.map(pageAnnualStatements, (annualStatement: IAnnualStatement) => (
            <Button
                href={`${process.env.API_HOST}/investor-annual-statements/${annualStatement.uuid}/download`}
                target='_blank'
            >
                {annualStatement.year} Statement <BiDownArrowAlt />
            </Button>
        ));

        return (
            <div className='content-box'>
                <h2>Annual Income Statements</h2>
                <p>These statements are to assist you in preparing your tax returns.</p>
                {statementsBlock}
                <div className='pagination-block'>
                    <Pagination
                        currentPage={currentPage}
                        itemCount={_.values(annualStatements).length}
                        onClickPage={this.onClickPage}
                        perPage={perPage}
                        showChangePerPage={false}
                    />
                </div>
            </div>
        );
    }

    private onClickPage(page: number): void {
        this.setState({
            currentPage: page,
        });
    }
}

function mapStateToProps(state: IGlobalState): IPropsSelector {
    return {
        annualStatements: currentInvestorAccountAnnualStatementsSelector(state, AccountTypeEnum.Marketplace),
        currentInvestor: currentInvestorSelector(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch): IPropsDispatch {
    return {
        annualStatementsList: () => dispatch(annualStatementsListAction(AccountTypeEnum.Marketplace)),
        currentInvestorGet: () => dispatch(currentInvestorGetAction()),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AnnualStatements);
